import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';


@Injectable({
  providedIn: 'root'
})
export class ProjectsService {

  constructor(private afdatabase: AngularFireDatabase) { }

  getProject() {
    return this.afdatabase.list('/products');
  }
  getProjectByStatus(status) {
    return this.afdatabase.list('/products', ref => ref.orderByChild('status').equalTo(status));
  }
  getProjectById(pid) {
    return this.afdatabase.object('/products/' + pid);
  }
  setProject(project) {
    return this.afdatabase.object('/products/' + project.pid).set(project);
  }
  setAvatarProject(avatar, pid) {
    return this.afdatabase.object('/products/' + pid + '/avatar').set(avatar);
  }
  setPlanProject(pid, plan) {
    return this.afdatabase.object('/products/' + pid + '/plan/').set(plan);
  }
  setUserProject(pid, action) {
    return this.afdatabase.object('/products/' + pid + '/users/' + action.uid).set(action);
  }
  addExpirationDate(pid, date) {
   return this.afdatabase.object('/products/' + pid + '/date_expiration').set(date);
  }
}
